<template>
  <div class="autocomplete">
    <input type="text" v-model="keyInput"
      :disabled="loading || airlineLoading" @keyup="filterAirlines"  @focus="filterAirlines"
      v-on:blur="clickOut" v-if="type === 'airlines'"
      :class="{'input':true, 'loading':loading, 'has-error':!!extra.error}" />

    <input type="text" v-model="keyInput" id="flightInput"
      :disabled="loading || airlineLoading" @keyup="filterFlights" @click="getFlightList"
      v-on:blur="clickOut" v-if="type === 'flight'" ref="flight"
      :class="{'input':true, 'loading':loading, 'has-error':!!extra.error}" />
    <span class="error-msg">{{ extra.error }}</span>

    <i class="fa fa-spinner fa-spin loader fa-2x" v-show="loading"></i>
    <transition name="slide-down">
      <ul class="suggestions" v-show="showSuggestion && !airlineLoading">
        <li v-for="(item, index) in suggestions" @click="selectItem(item)">
          <i class="fas fa-plane"></i>
          <div v-if="type === 'airlines'">
            <span>{{item.label}}</span>
          </div>
          <div v-else>
            <span><b>{{item.label}}</b></span>
            <small v-if="item.fromTo" v-html="item.fromTo"></small>
          </div>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import featureToggle from '@/modules/api/featureToggle'
// import ApiLocation from '../../modules/api/location'

export default {
  name: 'flight-input',
  props: ['value', 'type', 'extra', 'airlineLoading'],
  data () {
    return {
      keyInput: '',
      suggestions: [],
      showSuggestion: false,
      selectFromList: false,
      loading: false
    }
  },
  computed: {
    charter () { return this.$store.state.rsvpDetails.charter },
    airlineList () {
      if (this.type === 'airlines') {
        let gid = this.charter.enabled ? 'g' + this.charter.airportGeoId : this.extra.gid
        this.suggestions = this.$store.state.airlines.list[gid]
        return this.$store.state.airlines.list[gid]
      }
    },
    editData () { return this.$store.state.rsvpDetails.edit.details },
    isD2D () {
      let conf = CONFIG.brands.find(x => x.id === this.editData.tripInfo.brandId)
      if (conf) return conf.code === 'd2d'
      return false
    }
  },
  methods: {
    getFlightList () {
      let self = this
      let rsvpDetails = self.$store.state.rsvpDetails
      let original = rsvpDetails.basicInfo.tripInfo
      let current = rsvpDetails.edit.details.tripInfo

      // if ((original.pickupDate !== current.pickupDate ||
      //   original.airline !== current.airline) || self.suggestions.length <= 0
      // ) {
      let airportCode = current.airportCode
      let airlineCode = current.airlineCode
      let date = moment(current.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      let sdkUrl = ''

      if (!airlineCode) {
        let geofenceId = current.pickup.geofenceId
        if (current.pickup.geofenceType !== 'airport' && current.dropoff.geofenceType === 'airport') {
          geofenceId = current.dropoff.geofenceId
        }
        let index = self.$store.state.airlines.list['g' + geofenceId].findIndex(x => x.name === current.airline)
        if (index > -1) {
          airlineCode = self.$store.state.airlines.list['g' + geofenceId][index].code
        }
      }
      // if (current.isAirportDropoff && !current.isAirportPickup) {
      //   date = date.add(3, 'hours')
      // }

      if (airlineCode === null || airlineCode === '') {
        sdkUrl = '/availability/flights?airport=' + airportCode +
        '&date=' + date.format('YYYY-MM-DD') +
        '&time=' + date.format('HH:mm:ss')
      } else {
        sdkUrl = '/availability/flights?airport=' + airportCode +
        '&airline=' + airlineCode +
        '&date=' + date.format('YYYY-MM-DD') +
        '&time=' + date.format('HH:mm')
      }
      if (current.isAirportPickup) {
        sdkUrl+= '&departure=0'
      } else if (current.isAirportDropoff) {
        sdkUrl+= '&departure=1'
      }

      if (self.loading) { return }
      self.loading = true
      self.$sdk.get(sdkUrl, {}, res => {
        self.loading = false
        if (res.list) {
          let flights = []
          res.list.forEach(function (data) {
            let from = moment.tz(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD hh:mmA')
            let to = moment.tz(data.arrival.time.unix, 'X', data.arrival.time.timezone).format('MM/DD hh:mmA')
            let flightData = {
              code: data.flight.number,
              name: data.airline.code + ' ' + data.flight.number + ' '
              + data.departure.airportCode + '-' + data.arrival.airportCode,
              label: `${data.airline.code} ${data.flight.number} - ${data.airline.name}`,
              fromTo: `${data.departure.airportCode} (${from}) <i class="fas fa-chevron-right m-X-5"></i> ${data.arrival.airportCode} (${to})`,
              // + data.departure.airportCode + '-' + data.arrival.airportCode,
              isDomestic: data.isDomestic === 1
            }
            if (current.isAirportPickup) {
              flightData.time = moment(data.arrival.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
            } else if (current.isAirportDropoff) {
              flightData.time = moment(data.departure.time.unix, 'X', data.departure.time.timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
            }

            flights.push(flightData)
          })

          self.$store.commit('airlines/addFlights', flights)
          self.suggestions = flights
          self.showSuggestion = true
          self.selectFromList = false
        }
        self.$nextTick(() => self.$refs.flight.focus())
      })
      // } else {
      //   self.loading = false
      // }
    },
    filterAirlines () {
      let self = this
      let regex = new RegExp('^' + self.keyInput, 'i')
      let result = []
      let gid = self.charter.enabled ? 'g' + self.charter.airportGeoId : self.extra.gid
      let list = self.$store.state.airlines.list[gid]

      for (let i = 0; i < list.length; i++) {
        if (!regex.test(list[i].name)) { continue }
        result.push(list[i])
      }
      self.suggestions = result
      self.showSuggestion = true
      self.selectFromList = false
    },
    filterFlights () {
      let self = this
      let regex = new RegExp('^' + self.keyInput, 'i')
      let result = []
      let list = self.$store.state.airlines.flights

      if (list.length < 0) { return } // Manual

      for (let i = 0; i < list.length; i++) {
        if (!regex.test(list[i].code)) { continue }
        result.push(list[i])
      }
      self.suggestions = result
    },
    clickOut () {
      let self = this
      setTimeout(function () {
        if (self.keyInput.trim() === '') {
          if (self.type === 'airlines') {
            self.$store.commit('rsvpDetails/setAirline', {airline: '', airlineCode: ''})
          } else {
            self.$store.commit('rsvpDetails/setFlightNo', '')
          }
        } else if (!self.selectFromList) {
          if (self.type === 'airlines') {
            let index = self.airlineList.findIndex(x => x.name === self.keyInput)
            if (index > -1) {
              self.$store.commit('rsvpDetails/setAirline', {
                airline: self.airlineList[index].name,
                airlineCode: self.airlineList[index].code
              })
            } else {
              self.$store.commit('rsvpDetails/setAirline', {
                airline: self.keyInput,
                airlineCode: 'DD'
              })
            }
          } else {
            self.$store.commit('rsvpDetails/setFlightNo', self.keyInput)
            self.$store.commit('rsvpDetails/setLastFlightNo', '')
          }
        }

        self.showSuggestion = false
        self.selectFromList = false
      }, 100)
    },
    selectItem (item) {
      let self = this
      if (self.airlineLoading) return

      if (self.type === 'airlines') {
        self.keyInput = item.name
        self.$store.commit('rsvpDetails/setFlightNo', '')
        self.$store.commit('rsvpDetails/setAirline', {
          airline: item.name,
          airlineCode: item.code
        })
      } else {
        self.keyInput = item.code
        self.$store.commit('rsvpDetails/setFlightNo', item.code)
        self.$store.commit('rsvpDetails/setLastFlightNo', item.code)
      }

      let date = moment(item.time, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      date = date.add(5 - (date.format('mm') % 5), 'minutes').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      self.$store.commit('rsvpDetails/setSuggestedTime', date)
      self.$store.commit('rsvpDetails/setSuggestedTimeIsDomestic', item.isDomestic)

      self.selectFromList = true
    },
    flightChange () {
      this.$store.commit('rsvpDetails/setLastFlightNo', this.keyInput)
    }
  },
  watch: {
    value: function (value) {
      if (!this.$store.state.rsvpDetails.isAdd) {
        this.keyInput = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.autocomplete{
  position: relative;
  width: 100%;
}

.suggestions{
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 150px;
  z-index: 2;
  list-style: none;
  overflow: auto;
  padding: 0;
  margin: 0;
  box-shadow: 1px 1px 4px rgba(0,0,0, .3);

  li{
    background: #f6f6f6;
    padding:8px 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid #bbb;
    color: #333;
    display:flex;
    align-items: center;

    &:last-child{ border-bottom: none; }
    i{ margin-right: 10px; }
    span{ font-size:13px; }
    div{
      width: 100%;
      span{
        font-size: 14px;
        line-height: 1;
      }
      small{
        font-size: 13px;
        color: #888;
        display: block;
        line-height: 1;

        i{ margin: 0 5px; }
      }
    }
    .fa-exclamation-triangle{ color: #e2c84a;}
    .fa-map-marker{ color: #ea5c5c;}
    &:hover{
      background: #0D79F2;
      * {
        color: #fff;
      }
    }
    &.empty{ cursor: default; }
  }
}

.input{
  margin: 5px 0 0;
  color: #333;
  line-height: inherit;
  transition: all .15s ease;

  &.loading{ padding-right: 40px; }
  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background: #eee; }
}

.error-msg{
  font-size: 11px;
  line-height: 1.6;
  color: #f20d0d;
  font-style: italic;
  display: block;
}

.loader{
  position: absolute;
  top: 8px;
  right: 5px;
  z-index: 2;
  color: #aaa;
}

.slide-down-enter-active, .slide-down-leave-active {
  transition: all .3s ease;
}
.slide-down-enter, .slide-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/FlightInput.vue